import styled from 'styled-components';
import { Button } from '../button';

export const FormFieldWrapper = styled.div`
  width: 100%;

  label {
    display: block;
    margin-bottom: 5px;
  }

  .error {
    color: #da4444;
    color: ${(props) => (props.$errorColor ? props.$errorColor : '#da4444')};
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 120%; /* 14.4px */
    text-align: left;
    margin-top: 4px;
  }
`;

export const StyledInput = styled.input`
  width: 100%;
  border: none;
  background: none;
  display: flex;
  height: 48px;
  min-width: 180px;
  padding: 8px 8px 8px 16px;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  border-radius: 8px;
  background: ${(props) => (props.$bgColor ? props.$bgColor : '#27262B')};
  color: #afafaf;
  text-overflow: ellipsis;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 140%; /* 19.6px */

  &:hover {
    opacity: 0.9;
  }

  &:focus {
    color: #fff;
  }

  &::placeholder {
    color: ${(props) =>
      props.$placeholderColor ? props.$placeholderColor : '#27262B'};
  }

  ${({ $small }) =>
    $small &&
    `
    width: 55px;
    min-width: 0;
    height: 48px;
    padding:8px;
    text-align: center;
  `}

  ${({ $error }) =>
    $error &&
    `
    border: 1px solid #da4444;

    &:hover {
      border: 1px solid #da4444;
    }

    &:focus {
      border: 1px solid #da4444;
    }
  `}

  ${({ $valid }) =>
    $valid &&
    `
    border: 1px solid #08AD5E;

    &:hover {
      border: 1px solid #08AD5E;
    }

    &:focus {
      border: 1px solid #08AD5E;
    }
  `}
`;

export const InputWrapper = styled.div`
  position: relative;
`;

export const IconButton = styled(Button)`
  position: absolute;
  top: 50%;
  right: 4px;
  transform: translateY(-50%);
`;
